module.exports = __webpack_public_path__ + "img/circulo_banner_final.84a37cab.jpg";